'use client'

// oxlint-disable-next-line cf-web/banned-imports
import { SpinnerIcon } from 'primitives/icons'
import { m, AnimatePresence } from 'framer-motion'
import { tw } from 'utils/classnames'

type StudioLoadingSpinnerSize = 'medium' | 'small' | 'tiny'

export function StudioLoadingSpinner({
  loading,
  size,
}: {
  loading?: boolean
  size: StudioLoadingSpinnerSize
}) {
  return <AnimatePresence>{loading ? <Spinner size={size} /> : null}</AnimatePresence>
}

export function Spinner({ size }: { size: StudioLoadingSpinnerSize }) {
  const loadingSpinnerClasses = {
    sizes: {
      medium: ['size-4'].join(','),
      small: ['size-3'].join(','),
      tiny: ['size-2'].join(','),
    },
  }

  const loaderSpinnerClassName = tw('animate-spin', loadingSpinnerClasses.sizes[size])
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="bg-gray-700 absolute inset-0 flex items-center justify-center rounded-2 outline-none text-gray-400"
    >
      <SpinnerIcon className={loaderSpinnerClassName} />
    </m.div>
  )
}
